var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4769B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.5H24.25L25.25 17.5H21.75V15.5C21.75 14.47 21.75 13.5 23.75 13.5H25.25V10.14C24.924 10.097 23.693 10 22.393 10C19.678 10 17.75 11.657 17.75 14.7V17.5H14.75V21.5H17.75V30H21.75V21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3e7dcb5ea92897673d605d94ca7ad681.svg";
export { ForwardRef as ReactComponent };